module.exports = __webpack_public_path__ + "static/media/university-of-east-anglia.6b9132f9.png";